import { Loader2, Users } from "lucide-react";
import { useVendorClients } from "@/hooks/useVendor";
import { formatPrice, formatDate } from "@/lib/format";
import WhatsAppLink from "@/components/WhatsAppLink";

export default function VendorClients() {
  const { data: clients, isLoading } = useVendorClients();
  return (
    <div className="space-y-5" data-testid="vendor-clients">
      <div>
        <h1 className="font-display text-2xl font-extrabold text-ink">Mes clients</h1>
        <p className="mt-1 text-sm text-slate-500">Les clients ayant acheté vos produits et formations.</p>
      </div>
      {isLoading ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
      ) : !clients?.length ? (
        <div className="rounded-2xl border border-dashed border-line bg-white p-10 text-center">
          <Users className="mx-auto h-9 w-9 text-slate-300" />
          <p className="mt-3 text-sm text-slate-500">Aucun client pour le moment.</p>
        </div>
      ) : (
        <div className="overflow-hidden rounded-2xl border border-line bg-white">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-line text-left text-[11px] uppercase tracking-wide text-slate-400">
              <th className="p-4">Client</th><th className="p-4">Contact</th><th className="p-4">Commandes</th><th className="p-4">Total dépensé</th><th className="p-4">Dernière commande</th>
            </tr></thead>
            <tbody className="divide-y divide-line">
              {clients.map((c) => (
                <tr key={c.email} data-testid={`vclient-${c.email}`}>
                  <td className="p-4"><span className="font-semibold text-ink">{c.name || "—"}</span></td>
                  <td className="p-4 text-slate-600">{c.email}<br /><span className="text-xs"><WhatsAppLink phone={c.phone} fallback="" showIcon={false} /></span></td>
                  <td className="p-4 font-bold text-ink">{c.orders}</td>
                  <td className="p-4 font-bold text-emerald-600">{formatPrice(c.spent)}</td>
                  <td className="p-4 text-slate-500">{formatDate(c.last_order)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
